import userId from "./user_id";
import user from "./user";
import key from "./key";
import bankCard from "./bank_card";
import pin from "./pin";
import phone from "./phone";
import eye from "./eye";
import cross from "./cross";
import load from "./load";
import arrow from "./arrow";
import msg from "./msg";
import check from "./check";
import mail from "./mail";

const def = { userId, user, key, bankCard, pin, phone, eye, cross, load, arrow, msg, check, mail };

export default def;